// quick way to 'detect' mobile devices
let isMobile= window.matchMedia('(max-width: 767px)').matches;

document.addEventListener('DOMContentLoaded', function () {
    $(document).on('click', '.copy-customer-number', function (e) {
        let copyText = $('#customer-number').text();
        if (copyText) {
            navigator.clipboard.writeText(copyText);
            $('#customer-number').addClass('copied');
            setTimeout(function() {
                $('#customer-number').removeClass('copied');
            }, 1000);
        }
    });

    $('.is-mobile .popup-modal').on('show.bs.modal', function (e) {
        $('#overlay').addClass('overlay-show');
    }).on('hide.bs.modal', function (e) {
        $('#overlay').removeClass('overlay-show');
    });

    /**
     * Close the slide down panel (the filters) by tapping next to it.
     *
     * The panel dims the rest of the page through #overlay elsewhere in the
     * portal, but this theme gives that element no size, so there is nothing
     * outside the panel to click on. Hence the listener on the document.
     *
     * Closing runs through the panel's own close button instead of the
     * function behind it: that function lives in another bundle, while the
     * button carries a jQuery handler that is reachable from here. Its handler
     * stops the event, so the triggered click cannot come back around.
     */
    $(document).on('click', function (event) {
        const panel = $('#slide-down');

        if (! panel.length || ! panel.is(':visible')) {
            return;
        }

        // a tap inside the panel, or on the button that opened it, is not
        // "outside"
        if ($(event.target).closest('#slide-down, #show-slide-down').length) {
            return;
        }

        $('#hide-slide-down').trigger('click');
    });
});


